export default __webpack_public_path__ + "static/login-bg-00be917a1863c96d91d9c58ebcf0c5a0.png";